import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import NoRewards from './NoRewards'
import Rewards from './Rewards'

const RewardContainer = styled(Col)`
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 6px 26px 0 rgba(0, 0, 0, 0.08);
`
const CatalogTitle = styled.h6`
  color: #212529;
  font-size: 0.875em;
  line-height: 1.125em;
  padding-left: 1.563em;
`

export default function RewardCatalog() {
  return (
    <Row className="no-gutters mt-4 mb-5">
      <RewardContainer md={12} className="mb-3">
        <div className="text-right pr-3 pt-3">
          <FontAwesomeIcon icon={faEllipsisH} color="lightgrey" />
        </div>
        <CatalogTitle className="mb-5">Reward Catalog</CatalogTitle>
        {/*<NoRewards/>*/}
        <Rewards />
      </RewardContainer>
    </Row>
  )
}
